

































import Vue from "vue";
import ReporteCarreraBar from "./ReporteCarreraBar.vue";

type BarData = {
  nombre: string;
  total: number;
  sexo?: "F" | "M";
};

type TmpDataset = {
  labels: Record<string, boolean>;
  datasets: Record<string, Record<string, number>>;
};

export default Vue.extend({
  props: ["value"],
  components: {
    ReporteCarreraBar
  },
  data() {
    return {
      barColor: "#7EC0AD"
    };
  },
  methods: {
    getReport(
      query: string,
      label?: string,
      sort = true,
      backgroundColor = "#7EC0AD"
    ) {
      const listado = [...this.value[query]];

      if (sort) this.sortList(listado);

      const config = {
        labels: listado.map((v: BarData) => v.nombre),
        datasets: [
          {
            label: label ?? query.toUpperCase(),
            backgroundColor,
            data: listado.map((v: BarData) => v.total)
          }
        ]
      };

      return config;
    },

    /**
     * @param query
     * @param label
     * @param sort
     */
    getReportByGenre(query: string, label: string, sort = true) {
      const listado: BarData[] = [...this.value[query]];

      if (sort) this.sortList(listado);

      const tmpDataset: TmpDataset = {
        labels: {},
        datasets: {
          M: {},
          F: {}
        }
      };

      listado.forEach(v => {
        if (!(v.nombre in tmpDataset.labels)) {
          tmpDataset.labels[v.nombre] = true;
          tmpDataset.datasets.M[v.nombre] = 0;
          tmpDataset.datasets.F[v.nombre] = 0;
        }

        tmpDataset.datasets[v.sexo?.toUpperCase() || "M"][v.nombre] = v.total;
      });

      const labels = Object.keys(tmpDataset.labels);
      const datasets = Object.keys(tmpDataset.datasets).map((v: string) => {
        return {
          label: `${label} (Género: ${v})`,
          backgroundColor:
            v == "M"
              ? this.barColor
              : this.getComplementaryColor(this.barColor),
          data: Object.values(tmpDataset.datasets[v])
        };
      });

      return {
        labels,
        datasets
      };
    },

    /**
     * @param {array} list
     */
    sortList: (list: { nombre: string; total: number }[]) => {
      list.sort(function(a, b) {
        return b.total - a.total; // mayor a menor
      });
    },

    /**
     * @param color
     */
    getComplementaryColor: (color: string) => {
      const colorPart = color.slice(1);
      const ind = parseInt(colorPart, 16);
      let iter = ((1 << (4 * colorPart.length)) - 1 - ind).toString(16);
      while (iter.length < colorPart.length) {
        iter = "0" + iter;
      }
      return "#" + iter;
    }
  },
  computed: {
    /*
    generos() {
      return {
        labels: this.value.generos.map((v: any) => v.nombre),
        datasets: [
          {
            label: "Generos",
            backgroundColor: "#f87979",
            data: this.value.generos.map((v: any) => v.total)
          }
        ]
      };
    },
    tallas() {
      return {
        labels: this.value["tallas"].map((v: any) => v.nombre),
        datasets: [
          {
            label: "Tallas",
            backgroundColor: "#f87979",
            data: this.value["tallas"].map((v: any) => v.total)
          }
        ]
      };
    }
    */
  }
});
